// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3gCOa","colCheckbox":"styles_colCheckbox__Y_PR0"};